import { type Writable, writable } from "svelte/store";
import { User, UserRole, PlayGroupDTO } from "./walletapi";
import { service } from "./services";
// import { GetSessionToken } from "./user";

export const owners = writable<User[]>([]);
export const admins = writable<User[]>([]);
export const cashiers = writable<User[]>([]);
export const playGroupsList = writable<PlayGroupDTO[]>([]);

const TOKEN_STORAGE_KEY = "token";
function GetSessionToken() {
const token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
return token ? token : undefined; 
 }


type StaffRole = Exclude<UserRole, UserRole.Player>;
export const usersByRole: Record<StaffRole, Writable<User[]>> = {
    [UserRole.Owner]: owners,
    [UserRole.Admin]: admins,
    [UserRole.Cashier]: cashiers
};



export async function RefreshUsers()
{
    const staffList = await service.walletapi.listStaffUsers({ Token: GetSessionToken() });
    if (!staffList.Success || !staffList.Data) return;
    owners.set(staffList.Data.filter(user => user.Role === UserRole.Owner));
    admins.set(staffList.Data.filter(user => user.Role === UserRole.Admin));
    cashiers.set(staffList.Data.filter(user => user.Role === UserRole.Cashier));
}

//for playgroups 
export async function RefreshPlayGroups()
{
    let playgroupsList = await service.walletapi.playGroupsList({
        Token: GetSessionToken()
    });
    if (!playgroupsList.Success)
    {
        return;
    }

    playGroupsList.set(playgroupsList.Data!);
}


export function UserAdded(user: User)
{
    if (user.Role === UserRole.Player) return;
    const userList = usersByRole[user.Role];
    userList.update(list => {
        list.push(user);
        return list; // No aplicar ordenamiento
    });
};

export function UserChanged(user: User)
{
    if (user.Role === UserRole.Player) return;
    const userList = usersByRole[user.Role];
    
    userList.update(list => {
        let index = list.findIndex(p => p.Id == user.Id);
        if (index == -1)
        {
            // no such user
            return list;
        }

        // copy transaction if exists in old, but not in new
        let oldUser = list[index];
        if (oldUser.LastWalletTransaction &&
            !user.LastWalletTransaction)
        {
            user.LastWalletTransaction = oldUser.LastWalletTransaction;
            user.LastWalletTransaction = oldUser.LastWalletTransaction;
        }
        
        list[index] = user;

        return list;
    });
};

//pin for withdrawal
// export async function WithdrawalPin(pin: string)
// {
//     console.log('Iniciando WithdrawalPin');
//     let pinResponse = await service.walletapi.withdrawalPin({
//         Token: GetSessionToken(),
//         Data: {
//             Pin: pin
//         }
//     });

//     console.log('Respuesta de withdrawalPin:', pinResponse);
//     if (!pinResponse.Success)
//     {
//         console.error('Error al refrescar playgroups:', pinResponse);
//         return;
//     }

//     console.log('Pin de retiro:', pinResponse.Data);
// }
